/*global jQuery, google */
(function($) {

  'use strict';

  $(function() {

    $('.owl-carousel.bannerhome').owlCarousel({
      animateOut: 'fadeOut',
      mergeFit: true,
      responsiveRefreshRate: 200,
      margin : 0,
      loop: true,
      autoplay: true,
      autoplayTimeout: 3000,
      autoplayHoverPause: true,
      autoplaySpeed: 1000,
      items: 1,
      nav: true,
      dots: false,
      navText:['<div class=""><span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span></div>',
              '<div class=""><span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span></div>']
    });

    
  });

}(jQuery));